<iui-messages #messages class="ms-auto me-auto"> </iui-messages>

<div *ngIf="order">
    <div class="float-end">
        <ng-template [ngIf]="order.orderStatus === 'PaymentDue' || order.orderStatus === 'PaymentOverdue'  || order.orderStatus === 'AutoPay' ">
            <button class="btn btn-primary ms-3" id="pay-with-card" (click)="payWithCard()">
                Pay Online
            </button>
            <button class="btn btn-primary ms-3" id="check-or-wire" (click)="jumpToCheckOrWire()" id="jump-down">
                Check or Wire
            </button>
        </ng-template>
        <button class="btn btn-primary ms-3" (click)="printInvoice()" id="print-invoice">Print Invoice</button>
        <button class="btn btn-primary ms-3" (click)="downloadPdf()" id="download-pdf">Download Invoice</button>
        <button class="btn btn-primary ms-3" *ngIf="order.orderStatus === 'Paid'" (click)="viewReceipt()" id="view-receipt">View Receipt</button>
    </div>
    <h2 class="col-md-4"> Invoice: {{ orderId }} </h2>

    <div class="mt-5 row">
        <div class="col-md-3">
            <h3>Customer</h3>
            <div class="truncate" appShowToolTipIfTruncated tooltipPosition="top" [pTooltip]="order.company || ''">{{ order.company }}</div>
            <div>{{ order.billingFirstName }} {{ order.billingLastName }}</div>
            <div class="truncate" [pTooltip]="order.billingAddress1 || ''" appShowToolTipIfTruncated tooltipPosition="top">{{ order.billingAddress1 }}</div>
            <div class="truncate" [pTooltip]="order.billingAddress2 || ''" appShowToolTipIfTruncated tooltipPosition="top">{{ order.billingAddress2 }}</div>
            <div>{{ order.billingCity }}<span *ngIf="order.billingState">,</span> {{ order.billingState }} {{ order.billingZip }}</div>
            <div>{{ order.billingCountry | scrConfig:'country' }}</div>
        </div>
        <div class="col-md-3">
            <h3 class="mb-3">Details</h3>
            <div><strong>Invoice</strong>: {{ orderId }}<span *ngIf="(order.invoiceVersion || 0) &gt; 1">, Revision: {{ order.invoiceVersion }}</span></div>
            <div><strong>Invoice Date</strong>: {{ order.invoiceDate | date:'longDate' }}</div>
            <div><strong>Customer Number</strong>: {{ order.accountId }}</div>
            <div><strong>PO Number</strong>: {{ order.poNumber }}</div>
            <div><strong>Due Date</strong>: {{ order.paymentDueDate | date:'longDate' }}</div>
        </div>
        <div class="col-md-6 update-purchase-order" *ngIf="order && order.orderType !== 'BilledMonthly' && order.orderStatus !== 'Paid' && order.orderStatus !== 'Cancelled'">
            <h3 class="my-3">Update Purchase Order (Optional)</h3>
            <label for="purchase-order-number">Purchase Order Number</label>
            <input appScrText id="purchase-order-number" maxlength="120" [(ngModel)]="poNumber" />
            <button [disabled]="order.poNumber === poNumber || !poNumber" class="btn btn-primary ms-2" id="apply" (click)="updatePurchaseOrder()">Apply</button>
            <button [disabled]="!order.poNumber" class="btn btn-primary ms-2" id="remove" (click)="removePurchaseOrder()">Remove</button>
        </div>




    </div>

    <hr />

    <h3 class="my-5">Total Amount Due: {{ displayOnlyOrder?.totalPrice | scrMoney }}</h3>

    <hr />

    <h2 class="mt-5">Short Codes in Order</h2>

    <table class="table invoice-table mt-3">
        <thead>
            <th i18n>Line</th>
            <th i18n>Description</th>
            <th i18n>Short Code</th>
            <th i18n>Start Date</th>
            <th i18n>End Date</th>
            <th i18n class="money">List Price</th>
            <th i18n *ngIf="hasDiscount" class="money">Discount</th>
            <th i18n class="money">Amount</th>
        </thead>
        <tbody>
            <tr *ngFor="let lease of displayOnlyOrder?.leases; let i=index">
                <td>{{ i+1 }}</td>
                <td>{{ lease.description }}</td>
                <td>{{ lease.scId }}</td>
                <td>{{ lease.startDate | scrDatePending }}</td>
                <td>{{ lease.endDate | scrDatePending }}</td>
                <td class="money">{{ lease.listPrice | scrMoney }}</td>
                <td *ngIf="hasDiscount" class="money">
                    <div *ngFor="let discount of lease.discountList">
                        {{ discount.displayName }}
                    </div>
                    <div *ngIf="lease.discountAmount" class="money">
                        ({{ lease.discountAmount | scrMoney }})
                    </div>
                </td>
                <td class="money">{{ lease.price | scrMoney }}</td>
            </tr>
        </tbody>
        <tfoot>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td *ngIf="hasDiscount"></td>
                <td><strong>Total:</strong></td>
                <td class="money">{{ displayOnlyOrder?.totalPrice | scrMoney }}</td>
            </tr>
        </tfoot>
    </table>

    <hr />

    <h2 id="check-or-wire" class="mt-5 mb-3">Check or Wire Instructions</h2>

    <div class="mb-5">
        <p>If paying by check or wire transfer, please follow the remittance instructions below.</p>
        <p>Please include the invoice number and short code(s) on the check or wire transfer to avoid any processing delays.
        </p>
        <p>Make checks payable to <strong>iconectiv, LLC</strong></p>
        <div class="row">
            <div class="payment-info col-md-4">
                <span *ngFor="let line of config?.invoiceConfig?.remittanceAddress">
                    {{ line }}<br />
                </span>
            </div>
            <div class="payment-info col-md-4">
                <span *ngFor="let line of config?.invoiceConfig?.overnightMailCarrierPayments">
                    {{ line }}<br />
                </span>
            </div>
            <div class="payment-info col-md-4">
                <span *ngFor="let line of config?.invoiceConfig?.electronicPaymentsVia">
                    {{ line.replace('{{invoiceId}}', ''+orderId) }}<br />
                </span>
            </div>
        </div>
    </div>

    <footer *ngIf="config" class="mt-5">
        <div>
            For billing inquiries please call <strong>{{config.customerSupportPhone}}</strong>
            or send an email to <strong><a class="link" href="mailto: {{config.customerSupportEmail}}">{{config.customerSupportEmail}}</a></strong>.
        </div>
        <div class="mt-2">
            Please Note: Your program will not be approved and accepted until payment is provided in full.
        </div>
    </footer>
</div>